export const ProductData = [
    // {
    //     id: 1,
    //     name: "campnou",
    //     image: "https://res.cloudinary.com/dptohgiiu/image/upload/v1686078175/279863961_286630176889531_1468417031135548471_n_lsgzin.jpg",
    //     productType: "cancha sintetica",
    //     Price: "$"+ 50.000,
    //     rating: 5,
    //     timeLeft: 27,
    //     totalSales:7477
    // },
    // {
    //     id: 2,
    //     name: "SanSiro",
    //     image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuBqdOteVghyqUHvl0UXQ849AnfXoHzgOaokues1rjMqKLpY2UHlm6gTjMpreHo6aBPKU&usqp=CAU",
    //     productType: "cancha sintetica",
    //     Price: 50.000,
    //     rating: 5,
    //     timeLeft: 27,
    //     totalSales:7477
    // },
    // {
    //     id: 3,
    //     name: "Bernabeu",
    //     image: "",
    //     productType: "cancha sintetica",
    //     Price: 50.000,
    //     rating: 2,
    //     timeLeft: 27,
    //     totalSales:7477
    // },
    
    {
        id: 1,
        name: "campnou",
        desc: "10% de descuento dia lunes",
        title: "Cancha futbol 5",
        parag1: "Cancha con reja • luces • tienda • gradas de 30 puestos",
        parag2: "puede cancelar más tarde, así que asegure este excelente precio hoy!",
        cancel: "Cancelación gratuita",
        state: "Excelente",
        rating: 4,
        Price: "85.000",
        parag3: "Incluido petos y bolsas de agua",
        btndispo: "Mira disponibilidad",
        link: "/CanchaCampNou",
        image: "https://res.cloudinary.com/dptohgiiu/image/upload/v1686078175/279863961_286630176889531_1468417031135548471_n_lsgzin.jpg"
    },
    {
        id: 2,
        name: "Bernabeu",
        desc: "10% de descuento dia lunes",
        title: "Cancha futbol 5",
        parag1: "Cancha con reja • luces • tienda • gradas de 30 puestos",
        parag2: "puede cancelar más tarde, así que asegure este excelente precio hoy!",
        cancel: "Cancelación gratuita",
        state: "Excelente",
        rating: 3,
        Price: "50.000",
        parag3: "Incluido petos y bolsas de agua",
        btndispo: "Mira disponibilidad",
        link: "/CanchaBernabeu",
        image: "https://res.cloudinary.com/dptohgiiu/image/upload/v1686076930/C20KiJ-WIAAjDPs_r0c1qt.jpg"
    },
    {
        id: 3,
        name: "Gol Center",
        desc: "10% de descuento dia lunes",
        title: "Cancha futbol 5",
        parag1: "Cancha con reja • luces • tienda • gradas de 30 puestos",
        parag2: "puede cancelar más tarde, así que asegure este excelente precio hoy!",
        cancel: "Cancelación gratuita",
        state: "Excelente",
        rating: 5,
        Price: "50.000",
        parag3: "Incluido petos y bolsas de agua",
        btndispo: "Mira disponibilidad",
        link: "/CanchaSanSiro",
        image: "https://www.metegol.app/static/cd530e997927a7da4f153545f4c0b3c7/6ff2f/SoccerFields%252F8DTnKjrtQQBSm3NrowAc%252F3eb0c5bb-2abb-4d95-bee9-b48ef8b4886a.jpg"
    },
    {
        id: 4,
        name: "San Jose",
        desc: "10% de descuento dia lunes",
        title: "Cancha futbol 5",
        parag1: "Cancha con reja • luces • tienda • gradas de 20 puestos",
        parag2: "puede cancelar más tarde, así que asegure este excelente precio hoy!",
        cancel: "Cancelación gratuita",
        state: "Excelente",
        rating: 5,
        Price: "50.000",
        parag3: "Incluido petos y bolsas de agua",
        btndispo: "Mira disponibilidad",
        link: "/CanchaSanJose",
        image: "https://www.metegol.app/static/cd530e997927a7da4f153545f4c0b3c7/6ff2f/SoccerFields%252F8DTnKjrtQQBSm3NrowAc%252F3eb0c5bb-2abb-4d95-bee9-b48ef8b4886a.jpg"
    },
];


